import * as React from 'react';
import { Element } from 'slate/dist/interfaces/element';

const ElementContext = React.createContext<Element>(null);

export const withRootElement = (Component: any) => (props: any) => {
  return (
    <ElementContext.Provider value={props?.element}>
      <Component {...props} />
    </ElementContext.Provider>
  );
};

export const useRootElement = () => React.useContext(ElementContext);
